<template>
  <div class="">
    <!-- header desktop size -->
    <v-layout
      px-12
      v-if="$vuetify.breakpoint.mdAndUp"
      class="justify-space-between pt-4"
    >
      <v-flex>
        <img width="200px" :src="require('../assets/tcdc-color.png')" />
      </v-flex>
      <v-flex class="d-flex align-center" shrink>
        <v-layout>
          <v-flex style="cursor: pointer" shrink @click="goToHomePage">
            <span style="color: #000; font-size: 18px" class="mr-2"
              >เข้าสู่เว็บไซต์</span
            >
            <v-btn
              depressed
              small
              dark
              color="#FD5246"
              style="min-width: 30px;"
              class="px-0"
            >
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- header mobile size -->
    <v-layout
      justify-space-between
      py-3
      v-else
      class="header-height"
      style="background-color: #fff"
    >
      <v-flex>
        <v-layout>
          <v-flex class="shrink d-flex justify-start align-center">
            <v-btn depressed fab @click="drawer = !drawer" color="transparent">
              <!-- <img :src="require('../assets/menu.png')" /> -->
              <v-app-bar-nav-icon style="color: #EF3E2E"></v-app-bar-nav-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <v-navigation-drawer
              class="men"
              width="100%"
              height="100%"
              fixed
              v-model="drawer"
              style="background: #fff; top: 76px; margin-bottom: -76px;"
            >
              <v-layout pa-5 column>
                <v-flex>
                  <v-layout>
                    <v-flex>
                      <v-layout v-if="!access_token">
                        <v-flex>
                          <v-btn text>
                            <span style="font-size: 16px" @click="goLogin">{{
                              $t("login")
                            }}</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-divider v-if="!access_token" class="my-5"></v-divider>

                      <v-layout>
                        <v-flex>
                          <v-btn
                            class="mb-2"
                            text
                            height="100%"
                            @click="onActive(1)"
                          >
                            <span style="font-size: 16px">{{
                              $t("homepage")
                            }}</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-divider class="my-5"></v-divider>

                      <v-layout>
                        <v-flex>
                          <v-btn
                            class="mb-2 text-start"
                            text
                            height="100%"
                            @click="onActive(2)"
                          >
                            <span style="font-size: 16px">{{
                              $t("creator-portfolio")
                            }}</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-divider class="my-5"></v-divider>

                      <v-layout>
                        <v-flex>
                          <v-btn
                            class="mb-2 text-start"
                            text
                            height="100%"
                            @click="onActive(3)"
                          >
                            <span style="font-size: 16px">{{
                              $t("toprank")
                            }}</span></v-btn
                          >
                        </v-flex>
                      </v-layout>
                      <v-divider class="my-5"></v-divider>

                      <v-layout v-if="access_token">
                        <v-flex>
                          <v-btn text
                            ><span
                              style="font-size: 16px"
                              @click="onClickMenuList(2)"
                            >
                              {{ $t("logout") }}
                            </span></v-btn
                          >
                        </v-flex>
                      </v-layout>
                      <v-divider v-if="access_token" class="my-5"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-navigation-drawer>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex
        class="d-flex justify-end align-center pr-3"
        style="cursor:pointer;"
        @click="$router.push('/homepage')"
      >
        <img width="150px" :src="require('../assets/tcdc-color.png')" />
      </v-flex>
    </v-layout>

    <!-- body desktop size -->
    <v-layout
      v-if="$vuetify.breakpoint.mdAndUp"
      wrap
      class="flex-center px-12 mb-12"
    >
      <v-flex lg5 md6 sm6 class="d-flex align-center">
        <div class="flex-center" style="width: 100%;height: 100%">
          <v-img :alt="image_alt" width="100%" :src="imageLanding"></v-img>
        </div>
      </v-flex>

      <v-flex
        lg7
        md6
        class="d-flex align-center pl-12"
        style="padding-right: 3rem"
      >
        <v-layout class="justify-center">
          <v-flex xs12 class="">
            <!-- title -->

            <v-layout px-3 mt-lg-12 mt-md-4 class="justify-center">
              <v-flex
                lg12
                md12
                sm12
                :class="
                  $vuetify.breakpoint.smAndDown ? 'text-center' : 'text-start'
                "
                style="cursor: default"
              >
                <span
                  v-if="$vuetify.breakpoint.lgAndUp"
                  style="font-weight: bold;font-size: 50px"
                >
                  ผลงานแบบไหน <br />ที่คุณกำลังสนใจอยู่ ?
                </span>
                <span
                  v-else-if="$vuetify.breakpoint.mdAndUp"
                  style="font-weight: bold;font-size: 40px"
                >
                  ผลงานแบบไหน <br />ที่คุณกำลังสนใจอยู่ ?
                </span>
                <span v-else style="font-weight: bold;font-size: 35px">
                  ผลงานแบบไหนที่คุณ กำลังสนใจอยู่ ?
                </span>
              </v-flex>
            </v-layout>
            <v-layout mt-6 class="justify-center">
              <v-flex lg10 md10 sm6 mr-3>
                <v-text-field
                  v-model="keyword"
                  dense
                  outlined
                  flat
                  color="#FD5246"
                  background-color="#fff"
                  placeholder="ค้นหา"
                  prepend-inner-icon="search"
                  hide-details
                  @keyup.enter="search"
                ></v-text-field>
              </v-flex>
              <v-flex class="shrink d-flex align-center justify-end">
                <v-btn depressed outlined color="#FD5246" @click="search">
                  <span>{{ $t("search") }}</span>
                </v-btn>
              </v-flex>
            </v-layout>

            <!-- category type -->
            <v-layout px-3 mt-6>
              <v-flex class="d-flex align-center shrink mr-4">
                <span style="font-size: 20px">ประเภท </span>
              </v-flex>
              <v-flex class="d-flex align-center">
                <div class="line"></div>
              </v-flex>
            </v-layout>

            <!-- category list -->
            <v-layout>
              <v-flex xs12 class="text-center">
                <v-layout wrap>
                  <v-flex
                    class="lg3 md4 pa-2"
                    v-for="item in categorys"
                    :key="item.id"
                  >
                    <v-layout
                      class="menu-lists"
                      :class="'icon_' + item.id"
                      @click="clickCategory(item)"
                    >
                      <v-flex
                        shrink
                        class="d-flex justify-center align-center pl-2"
                      >
                        <v-img
                          lazy-src=""
                          :width="item.id === 0 ? '18' : '30'"
                          :src="item.default_icon"
                        ></v-img>
                      </v-flex>
                      <v-flex
                        style="font-size: 12px "
                        class="d-flex text-start align-center px-1"
                      >
                        <!-- <div class="one-line"> -->
                        <div>
                          {{ item.name_th }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- <pre class="text-start warning">{{ categorys }}</pre> -->

            <!-- designer -->
            <v-layout px-3 mt-6 mb-3>
              <v-flex class="d-flex align-center shrink mr-4">
                <span style="font-size: 20px">นักสร้างสรรค์</span>
              </v-flex>
              <v-flex class="d-flex align-center">
                <v-divider></v-divider>
              </v-flex>
            </v-layout>

            <v-layout
              v-if="designers.length > 0"
              class="justify-space-between"
              wrap
            >
              <v-flex
                style="cursor: pointer;"
                class="xs3 d-flex justify-center flex-column"
                v-for="(designer, i) in designers.slice(0, 4)"
                :key="i"
              >
                <v-layout>
                  <v-flex
                    class="px-8 flex-center"
                    style="cursor: pointer;background-color: #F8F8F8;"
                    @click="goToDesigner(designer)"
                  >
                    <v-img
                      aspect-ratio="1"
                      style="border-radius: 50%;width: 70px"
                      :src="
                        designer.profile &&
                        designer.profile.mem_info &&
                        designer.profile.mem_info.avatar
                          ? url +
                            imgPath +
                            'images_profile/' +
                            designer.profile.mem_info.avatar
                          : require('../assets/user_profile.png')
                      "
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex
                    class="ellipsis mt-3"
                    style="font-size: 12px;text-align: center;"
                  >
                    {{ checkName(designer) }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- body mobile size -->
    <div v-else>
      <div class="line"></div>
      <v-layout wrap class="mb-12 px-2 flex-center" style="height: auto">
        <v-flex lg6 md6 sm6 class="d-flex align-center">
          <v-layout>
            <v-flex class="flex-center" style="width: 100%;height: 100%">
              <img
                width="100%"
                src="../assets/landingpage/landing-image-01.png"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex lg6 md6 class="d-flex align-center">
          <v-layout class="justify-center">
            <v-flex xs12>
              <!-- titel -->
              <v-layout mt-lg-12 mt-md-4 class="justify-center">
                <v-flex class="flex-center text-center">
                  <span style="font-weight: bold;font-size: 40px">
                    ผลงานแบบไหน <br />
                    ที่คุณกำลังสนใจอยู่ ?
                  </span>
                </v-flex>
              </v-layout>

              <!-- Search -->
              <v-layout mt-lg-12 mt-md-4 mt-6 class="justify-center">
                <v-spacer></v-spacer>
                <v-flex sm8 mr-3>
                  <v-text-field
                    v-model="keyword"
                    dense
                    outlined
                    flat
                    color="#FD5246"
                    background-color="#fff"
                    placeholder="ค้นหา"
                    prepend-inner-icon="search"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex class="d-flex align-center">
                  <v-btn
                    :loading="isLoadingSearch"
                    depressed
                    outlined
                    color="#FD5246"
                    @click="search"
                  >
                    <span>{{ $t("search") }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <!-- ประเภท -->
              <v-layout mt-12>
                <v-flex class="d-flex align-center shrink mx-3">
                  <span>ประเภท </span>
                </v-flex>
                <v-flex class="d-flex align-center">
                  <div class="line"></div>
                </v-flex>
              </v-layout>

              <!-- category list -->
              <v-layout>
                <v-flex xs12 class="text-center">
                  <v-layout wrap>
                    <v-flex
                      class="xs6 pa-2"
                      v-for="item in categorys"
                      :key="item.id"
                    >
                      <v-layout
                        class="menu-lists pa-3"
                        :class="'icon_' + item.id"
                        @click="clickCategory(item)"
                      >
                        <v-flex
                          shrink
                          class="d-flex justify-center align-center"
                        >
                          <v-img
                            lazy-src=""
                            width="40"
                            :src="item.default_icon"
                          ></v-img>
                        </v-flex>
                        <v-flex
                          style="font-size: 12px"
                          class="d-flex text-start align-center pl-3"
                        >
                          {{ item.name_th }}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <!-- นักสร้างสรรค์ -->
              <v-layout mt-12>
                <v-flex class="d-flex align-center shrink mx-4">
                  <span>นักสร้างสรรค์</span>
                </v-flex>
                <v-flex class="d-flex align-center">
                  <div class="line"></div>
                </v-flex>
              </v-layout>

              <v-layout wrap v-if="designers.length > 0">
                <v-flex
                  class="xs6 sm3 d-flex justify-center pa-3 mb-3 flex-column"
                  v-for="(designer, i) in designers.slice(0, 4)"
                  :key="i"
                >
                  <v-layout>
                    <v-flex
                      @click="goToDesigner(designer)"
                      class="px-8 flex-center"
                      style="cursor: pointer;background-color: #F8F8F8;"
                    >
                      <v-img
                        aspect-ratio="1"
                        style="border-radius: 50%;width: 30%"
                        :src="
                          designer.profile &&
                          designer.profile.mem_info &&
                          designer.profile.mem_info.avatar
                            ? url +
                              imgPath +
                              'images_profile/' +
                              designer.profile.mem_info.avatar
                            : require('../assets/user_profile.png')
                        "
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex
                      class="ellipsis mt-3"
                      style="font-size: 12px;text-align: center;"
                    >
                      {{ checkName(designer) }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>

    <v-row justify="center" style="position: relative;" v-if="isShowLanding">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-tran"
      >
        <v-card
          flat
          tile
          :style="
            is_show == 0
              ? `background-color: ${bg_color}`
              : `background-image: url(${bg_image})`
          "
        >
          <v-layout
            :style="
              is_show == 0
                ? `background-color: ${bg_color}`
                : `background-image: url(${bg_image})`
            "
            class="d-flex justify-center align-center"
          >
            <img
              v-if="$vuetify.breakpoint.lgAndUp"
              width="60%"
              :src="mainImageLanding"
            />
            <img
              v-if="$vuetify.breakpoint.md"
              width="70%"
              :src="mainImageLanding"
            />
            <img
              v-if="$vuetify.breakpoint.sm"
              width="70%"
              :src="mainImageLandingMobile"
            />
            <img
              v-if="$vuetify.breakpoint.xs"
              width="100%"
              :src="mainImageLandingMobile"
            />
          </v-layout>

          <v-layout wrap justify-center class="py-8 d-flex align-center">
            <!-- position: absolute;right: 0;left: 0;bottom: 0;  -->
            <v-flex xs12 sm10 md12 class="d-flex justify-center align-center">
              <v-layout justify-center wrap>
                <v-flex xs12 sm6 md4 mb-4 class="flex-center">
                  <img
                    width="200px"
                    :src="require('../assets/tcdc-color.png')"
                  />
                </v-flex>

                <v-flex xs12 sm6 md4 class="flex-center mb-4">
                  <v-btn
                    :style="
                      `background-color: ${btn_bg_color};color: ${btn_text_color};`
                    "
                    depressed
                    large
                    @click="onClickDialog"
                    style="min-width: 30px;"
                  >
                    <span style="font-size: 16px" class="mr-2 font-weight-bold">
                      เข้าสู่เว็บไซต์
                    </span>
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </v-flex>

                <v-flex xs12 sm12 md4 mb-4 class="flex-center">
                  <div>
                    <!-- style="border: solid 2px #FD5246; border-radius: 30px;color: #fff" -->

                    <span
                      style="border-radius: 30px;"
                      :style="
                        `background-color: ${btn_bg_color};color: ${btn_text_color};`
                      "
                      class="py-2 px-4 txt-detail"
                    >
                      connect@cea.or.th (+66) 2 105 7400 ext. 118 - 131
                    </span>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-row>

    <loading
      color="#FD5246"
      :active.sync="isLoadingOnClickCate"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>

    <loading
      color="#FD5246"
      :active.sync="isLoadingModal"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SlideGroup from "../components/slide_group/SlideGroup";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { domain, imgPath } from "../services/Constants";

export default {
  name: "LandingPage",
  components: {
    SlideGroup,
    Loading,
  },
  data: () => ({
    dialog: true,
    isHovering: false,
    imgPath: imgPath,
    url: domain,
    isLoading: false,
    isLoadingModal: false,
    isLoadingSearch: false,
    isLoadingOnClickCate: false,
    fullPage: true,
    drawer: false,
    designers: [],
    keyword: "",
    categorys: [
      {
        id: 0,
        name_th: "รวม",
        name_en: "All",
        icon: "subject",
        portfolio_total: "",
      },
    ],
    imageLanding: null,
    image_alt: "",
    mainImageLanding: null,
    mainImageLandingMobile: null,
    is_show: "",
    bg_color: "",
    bg_image: "",
    btn_bg_color: "",
    btn_text_color: "",
  }),
  computed: {
    ...mapState({
      access_token: (state) => {
        return state.auth.access_token;
      },
      isShowLanding: (state) => {
        return state.Common.isShowLanding;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  async created() {
    console.log(this.isShowLanding);
    await this.getMostDesignPortfolio(1);
    await this.getCategory();
    await this.getImageLanding();
    await this.getMainImageLanding();
  },
  methods: {
    async getImageLanding() {
      const res = await this.$store.dispatch("Common/getImageLanding");
      this.imageLanding = res.full_path;
      this.image_alt = res.image_path;
    },
    async getMainImageLanding() {
      const res = await this.$store.dispatch("Common/getMainImageLanding");
      this.mainImageLanding = res.full_path;
      this.mainImageLandingMobile = res.full_path_mobile;
      this.is_show = res.is_show;
      this.bg_color = res.bg_color;
      this.bg_image = res.bg_image_fullpath;
      this.btn_bg_color = res.btn_bg_color;
      this.btn_text_color = res.btn_text_color;
    },

    getCategory() {
      if (this.loadingDialog === false) {
        this.isLoading = true;
      }
      this.$store
        .dispatch("Categoty/getCategory")
        .then((res) => {
          this.categorys[0].portfolio_total = res.data.count_port_all;
          this.categorys[0].default_icon = this.checkIcon("All");
          res.data.categories_list.forEach((data) => {
            this.categorys.push({
              id: data.id,
              name_th: data.name_th,
              name_en: data.name_en,
              portfolio_total: data.portfolio_total,
              default_icon: this.checkIcon(data.name_en),
            });
          });
          this.fade = true;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },

    onClickDialog() {
      this.isLoadingModal = true;
      this.dialog = false;
      this.getMostDesignPortfolio(1);

      setTimeout(() => {
        this.isLoadingModal = false;
      }, 1000);
    },

    onActive(val) {
      this.isActive = val;
      switch (val) {
        case 1:
          this.$store.dispatch("portfolio/clearActiveMenuCate", val);
          this.$router.push("/homepage");
          break;
        case 2:
          this.$store.dispatch("portfolio/clearActiveMenuCate", val);
          this.$router.push("/creator");
          break;
        case 3:
          this.$store.dispatch("portfolio/clearActiveMenuCate", val);
          this.$router.push("/toprank");
          break;
      }
    },

    onClickMenuList(id) {
      if (id === 1) {
        this.$store.dispatch("profile/onGetProfileInfo", this.user.profile_id);
        this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
        this.$router.push("/profile-about");
      }
      if (id === 2) {
        this.$swal({
          text: "คุณต้องการออกจากระบบ ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#FD5246",
          cancelButtonColor: "#525252",
          confirmButtonText: "ใช่",
          cancelButtonText: "ยกเลิก",
        })
          .then((result) => {
            if (result.value) {
              this.$store
                .dispatch("auth/logout")
                .then((res) => {
                  this.$store.dispatch("profile/clearPersonalInfo").then(() => {
                    this.$router.push("/login");
                  });
                })
                .catch((err) => {
                  console.log(err);
                  this.$store.dispatch("profile/clearPersonalInfo");
                  this.$router.push("/login");
                });
            }
          })
          .finally(() => {
            this.$store.dispatch("profile/clearPersonalInfo");
            this.$router.push("/login");
          });
      }
    },

    goToHomePage() {
      this.$store.dispatch("portfolio/clearActiveMenuCate", 1);
      this.$router.push("/homepage");
    },

    clickCategory(item) {
      console.log(item);
      this.$router.push(
        `/portfolio-category/${
          this.switchLanguage === "th" ? item.name_th : item.name_en
        }${item.name_th === "รวม" ? "" : "-" + item.id}`
      );
      // let data = {
      //   id: item.id,
      //   page: 1,
      // };
      // this.isLoadingOnClickCate = true;
      // this.$store
      //   .dispatch("portfolio/getPortfolioByIdCategory", data)
      //   .then((res) => {
      //     this.isLoadingOnClickCate = false;
      //     if (this.currentRouteName !== "AllPortfolioByCategory") {
      //       this.$router.push(`/portfolio-category/${item.name_th}`);
      //     }
      //   });
    },

    getMostDesignPortfolio() {
      this.isLoading = true;
      this.$store.dispatch("portfolio/getMostDesignPortfolio").then((res) => {
        this.designers = res;
        this.isLoading = false;
      });
    },

    goLogin() {
      if (this.$route.path !== "/login") {
        this.$store.dispatch("portfolio/clearActiveMenuCate", 3);
        this.$router.push("/login");
      } else {
        this.drawer = false;
      }
    },
    goToDesigner(item) {
      this.$store.dispatch("portfolio/clearPaginate");
      this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
      this.$router.push({
        path: `/profile/${
          item.profile.mem_info && item.profile.mem_info.domain_name
            ? item.profile.mem_info.domain_name
            : item.profile.profile_id
        }`,
      });
    },

    search() {
      if (!this.keyword) {
        this.$swal({
          text: "กรุณากรอกคำค้นหา!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#FD5246",
          confirmButtonText: "ตกลง",
        });
      } else {
        this.isLoadingSearch = true;
        let data = { page: 1, keyword: this.keyword };
        this.$store
          .dispatch("portfolio/getPortfolioBySearch", data)
          .then((res) => {
            this.isLoadingSearch = false;
            this.$router.push({
              path: "/search",
              query: { keyword: this.keyword },
            });
          });
      }
    },

    checkName(val) {
      if (val.profile) {
        if (!val.profile.name_th && !val.profile.last_th) {
          return val.profile.email;
        } else {
          if (val.profile.name_th && val.profile.last_th) {
            return val.profile.name_th + " " + val.profile.last_th;
          } else {
            return val.profile.name_th;
          }
        }
      } else {
        return "";
      }
    },

    checkIcon(iconName) {
      switch (iconName) {
        case "Design":
          return require("../assets/icons/whiteIcon/การออกแบบ@2x.png");
        case "Architecture":
          return require("../assets/icons/whiteIcon/สถาปัตยกรรม@2x.png");
        case "Fashion":
          return require("../assets/icons/whiteIcon/แฟชั่น@2x.png");
        case "Craft":
          return require("../assets/icons/whiteIcon/งานฝีมือ@2x.png");
        case "Advertising":
          return require("../assets/icons/whiteIcon/การโฆษณา@2x.png");
        case "Visual Arts":
          return require("../assets/icons/whiteIcon/ทัศนศิลป์@2x.png");
        case "Food":
          return require("../assets/icons/whiteIcon/อาหารไทย@2x.png");
        case "Cultural and Heritage Tourism":
          return require("../assets/icons/whiteIcon/การท่องเที่ยวเชิงวัฒนธรรม@2x.png");
        case "Film":
          return require("../assets/icons/whiteIcon/ภาพยนต์@2x.png");
        case "Publishing":
          return require("../assets/icons/whiteIcon/การพิมพ์@2x.png");
        case "Software":
          return require("../assets/icons/whiteIcon/ซอฟแวร์@2x.png");
        case "Music":
          return require("../assets/icons/whiteIcon/ดนตรี@2x.png");
        case "Performing Arts":
          return require("../assets/icons/whiteIcon/ศิลปะการแสดง@2x.png");
        case "Broadcasting":
          return require("../assets/icons/whiteIcon/การแพร่ภาพและกระจายเสียง@2x.png");
        case "Thai Traditional Medicine":
          return require("../assets/icons/whiteIcon/การแพทย์แผนไทย@2x.png");
        default:
          return require("../assets/icons/whiteIcon/ทั้งหมด@2x.png");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu-lists {
  border-radius: 5px;
  display: flex;
  justify-items: center;
  align-content: center;
  width: 100%;
  min-height: 50px;
  height: 50px;
  // height: auto;
  color: #fff;
  background-color: #9c9c9c;
}
.menu-lists:hover {
  cursor: pointer;
}

// Hover box menu
.icon_0:hover {
  background-color: #ef3e2e;
}
.icon_10:hover {
  background-color: #74bf92;
}
.icon_11:hover {
  background-color: #ac9277;
}
.icon_12:hover {
  background-color: #c98074;
}
.icon_1:hover {
  background-color: #957722;
}
.icon_9:hover {
  background-color: #e19705;
}
.icon_4:hover {
  background-color: #4cc2d2;
}
.icon_13:hover {
  background-color: #e47645;
}
.icon_15:hover {
  background-color: #8a233d;
}
.icon_5:hover {
  background-color: #cd4646;
}
.icon_7:hover {
  background-color: #92b4cb;
}
.icon_8:hover {
  background-color: #9f939a;
}
.icon_2:hover {
  background-color: #733c90;
}
.icon_3:hover {
  background-color: #684c41;
}
.icon_6:hover {
  background-color: #3b5fa6;
}
.icon_14:hover {
  background-color: #28645e;
}

.bg-gradient {
  background: rgb(152, 204, 254);
  background: linear-gradient(
    0deg,
    rgba(152, 204, 254, 1) 0%,
    rgba(140, 210, 251, 1) 60%,
    rgba(140, 210, 251, 1) 100%
  );
}
.hover-login:hover {
  cursor: pointer;
  color: #fd5246;
}

.landing-image-desktop {
  background-image: url("../assets/landingpage/landing-image.png");
  width: 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

.landing-image-mobile {
  background-image: url("../assets/landingpage/landing-image-mobile.png");
}

.hover-register {
  color: #fd5246;
}

.hover-register:hover {
  cursor: pointer;
  color: #000;
}

.ellipsis {
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.one-edge-shadow {
  -webkit-box-shadow: 0 8px 6px -6px black;
  -moz-box-shadow: 0 8px 6px -6px black;
  box-shadow: 0 4px 5px -5px black;
}
.line {
  width: 100%;
  padding: 0.5px;
  background-color: rgba(0, 0, 0, 0.25);
}
.centered {
  width: 100%;
  position: fixed;
  top: 40%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}
.category-btn {
  height: 200px;
}
#btn-landing .v-btn {
  background-color: #fd5246;
  color: #fff;
}
#btn-landing .v-btn:hover {
  background-color: #fff;
  border: 2px solid #fd5246;
  color: #fd5246;
}
</style>
